import $ from 'jquery';
import Parallax from './Parallax';

const getRandomInteger = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export default class Hero {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.preprocess();
    this.ready();
  }

  preprocess() {
    // Randomize the image display.
    const $images = this.$element.find('.field-image img');
    const src = $images.eq(getRandomInteger(0, $images.length - 1)).attr('data-src');
    if (src.length) {
      this.$element.find('.node-upper-image').each((i, element) => {
        $(element).find('.field-image.c1 a').css('background-image', `url(${src})`).addClass('bgi');
        element.Parallax = new Parallax(element);
      });
    }

    // Append read more to the node header for ease of theme.
    this.$element.find('.node-header a').append(this.$element.find('.read-more-text'));
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
